import React from 'react';
import './../../../styles/without-pictures.css';

const WithOutPictures = ({ typePictures = '', message = '' }) => {
    return (
        <div className="main-without-pictures">
            <span className="text-md">
                {`El cliente no registró ${typePictures}`}
                <br/>
            </span>
            <p className="text-md">{(message) ? '¡No olvides revisar las fotos del auto para verificarlo!': null}</p>
            <div className="main-picture">
                <img src="./images/boladeldesierto.png" />
            </div>
        </div>
    )
}

export default WithOutPictures;



// WEBPACK FOOTER //
// ./src/components/shared/without-photos/index.js